
import { Component, Vue, Prop } from "vue-property-decorator"

import users from "@/graphql/user/users.graphql"
import groups from "@/graphql/group/groups.graphql"
import * as cdn from "@coredination/components"
import { User } from "@coredination/common"
import { GroupMembership } from "@coredination/common/dist/model/user"

@Component({
    apollo: {
        me: cdn.graphql.me,
        users,
        groups,
    }
})
export default class PlanningFilterDialog extends Vue {
    searchUser: string | null = null
    minSearchCharacters: number = 3

    me?: User
    users?: [User]

    @Prop() readonly listTypeFilter!: any

    @Prop({ default: false })
    value!: boolean
    get show() {
        return this.value
    }
    set show(value: boolean) {
        this.$emit("input", value)
    }

    select(type: string, value: string, name: string) {
        var listTypeFilter: any = {
            type: type,
            value: value,
            name: name
        }
        console.log(listTypeFilter)
        this.$emit("change-filter", listTypeFilter)
        this.show = false
    }

    get listTypes(): string[] | void {
        if (!this.me || !this.me.permissions || this.me.permissions.length == 0) return
        var types: string[] = []
        if (this.me.permissions.includes('view_jobs') && this.allJobs) {
            types.push('mine')
            types.push('all')
            types.push('unassigned')
        }
        if (this.me.hasPermissionInAnyGroup('schedule_self')) {
            if (!types.includes('mine')) types.push('mine')
            if (!types.includes('unassigned')) types.push('unassigned')
        }
        if (this.me.hasPermissionInAnyGroup('do_work')) {
            if (!types.includes('mine')) types.push('mine')
        }
        return types
    }

    get canFilterUsers(): boolean {
        return true
    }

    get loading() {
        return this.$apollo.queries.me.loading || this.$apollo.queries.users.loading
    }

    get searchUsers() {
        if (!this.users || this.users.length <= 0) return []
        if (!this.searchUser || this.searchUser.length < this.minSearchCharacters) return []
        return this.users.filter((user: any)=> {
            return user && this.searchUser &&
                (
                    user.fullName && user.fullName.toLowerCase().includes(this.searchUser.toLowerCase())
                    || user.userName && user.userName.toLowerCase().includes(this.searchUser.toLowerCase())
                )
        })
    }

    get allJobs() {
        return this.me && this.me.hasPermissionInAnyGroup('view_others_jobs')
    }
}
